import React from 'react';
import { ButtonClean, Colors, Tooltip } from '@fourthwall/components';
import { QuestionMarkIcon } from '@fourthwall/icons';
import { getAffiliateDescription } from '@modules/Dashboard/Home/modules/recommendations/useReferralRecommendation/utils/getAffiliateDescription';
import * as S from './ReferralsListItem.styled';
export const ReferralListItem = ({ item }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.LeftContainer, null,
                React.createElement(S.ShopNameContainer, null,
                    React.createElement(ButtonClean, { label: item.shopName, href: `${item.shopDomain}`, target: "_blank" }),
                    React.createElement(Tooltip, { reference: React.createElement(QuestionMarkIcon, { color: Colors.GS600, width: 12 }) }, getAffiliateDescription(item.affiliateTypeId).description)),
                React.createElement(S.AffiliateType, null, getAffiliateDescription(item.affiliateTypeId).name)),
            React.createElement(S.DateRange, null,
                item.fromTime.toLocaleDateString(),
                " - ",
                item.toTime.toLocaleDateString()))));
};
